import { render, staticRenderFns } from "./HorseStationnement.vue?vue&type=template&id=30afbbdd&"
import script from "./HorseStationnement.vue?vue&type=script&lang=js&"
export * from "./HorseStationnement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports